import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DialogContent, Grid } from "@mui/material";
import { LocaleContext } from "../../../routing/LangRouter";
import { t } from "i18next";

//import general components
import BaseDialog from "../base-dialog/base-dialog";
import { BaseButton } from "../base-button/base-button";

//import images and icons
import { Timer1 } from "iconsax-react";

function ExpirationResultModal({ hasList, requestExpirationDate, setRequestFlag, uid, setUid, resetList, resetFilters }) {
    //general variables
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);

    //handle open modal
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
        const checkExpiration = () => {
            const currentDate = new Date();
            const expirationDate = new Date(requestExpirationDate);
            if (currentDate > expirationDate) {
                setIsModalOpen(true);
                setUid?.(null);
            }
        };

        if (!!uid) {
            // Check every minute (or any interval you prefer)
            const interval = setInterval(checkExpiration, 20000);
            // Cleanup interval on component unmount
            return () => clearInterval(interval);
        }
    }, [uid, requestExpirationDate]);

    // handles the research action by setting the request flag, resetting the uid, and closing the modal.
    const handleResearch = () => {
        setRequestFlag?.(true);
        resetList?.();
        resetFilters?.();
        handleClose();
    };

    //handle close modal
    const handleClose = () => {
        setIsModalOpen(false);
    };

    //handle navigate to home
    const navigateToHome = () => {
        navigate(`/${locale}`);
    };

    return (
        <BaseDialog open={isModalOpen} top="auto" maxWidth="sm">
            <DialogContent>
                <Grid container item xs={12} justifyContent="center" rowGap={3}>
                    <Grid container item xs={12} rowGap={1} direction="column" justifyContent="center" alignItems="center">
                        <Timer1 size="70" color="var(--primary-color)" />
                        <h2>{t("SearchExpired")}</h2>
                        <h5>{t("refreshYourSearch")}</h5>
                    </Grid>
                    <Grid container item xs={10} justifyContent="space-between">
                        <Grid container item xs={5.8}>
                            <BaseButton
                                text={`${t("update")} ${t("search")}`}
                                color="primary"
                                radius="radius-10"
                                size="large"
                                handleClick={handleResearch}
                            />
                        </Grid>
                        <Grid container item xs={5.8}>
                            <BaseButton text={t("backToHomePage")} color="outline" radius="radius-10" size="large" handleClick={navigateToHome} />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </BaseDialog>
    );
}

export default ExpirationResultModal;
